module.exports = __webpack_public_path__ + "img/step46_a_lift_printer_lowest (1).e1541c38.png";